import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				{ /* Axes, and a line rising over them. */ }
				<path d="M3 3h1.6v15.4H21V20H3V3z" />
				<path
					d="M6.5 15.5l4-4.5 3 2.5 5.5-7"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<circle cx="19" cy="6.5" r="1.9" />
			</svg>
		),
	},
} );
